<template>
  <div id="compreSportsMeet_medalTally" v-show="currThemeObj">
    <div class="select_area">
      <marathon_select_opt
        :currThemeObj="currThemeObj"
        :data="selectOptData"
        @changeSelectEvent="changeSelect"
        :manualRefresh="themeList.length > 1 ? selectOpt_manualRefresh : null"
      ></marathon_select_opt>
    </div>
    <div class="tableScrollArea" ref="tableParentDom">
      <multiLevelFold_table
        :currThemeObj="currThemeObj"
        :currCid="currCid"
        :currSid="currSid"
        :tableMode="tableMode"
        :parentWidthPx="parentWidthPx"
        :isScrollFlag="isScrollFlag"
        :variableColWidthVw="variableColWidthVw"
        :tableCellDefaultWidthVw="tableCellDefaultWidthVw"
        :defaultWidthVwNum="defaultWidthVwNum"
        :tableColumnData="tableColumnData"
        :tableData="tableData"
        :tableHeightPx="tableHeightPx"
        :expandKey="expandKey"
        :expandColumnCallback="expandColumnCallback"
        @toParentEvent="toParentEventHandler"
        v-show="tableData && tableData.length > 0"
      ></multiLevelFold_table>
      <span class="publishBtn" @click="clickPublicTheme()">
        <svg
          t="1692698307306"
          class="publishBtn_icon"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="9670"
          width="50%"
          height="50%"
        >
          <path
            d="M853.333333 533.333333a32 32 0 0 1 64 0v266.666667c0 64.8-52.533333 117.333333-117.333333 117.333333H224c-64.8 0-117.333333-52.533333-117.333333-117.333333V256c0-64.8 52.533333-117.333333 117.333333-117.333333h277.333333a32 32 0 0 1 0 64H224a53.333333 53.333333 0 0 0-53.333333 53.333333v544a53.333333 53.333333 0 0 0 53.333333 53.333333h576a53.333333 53.333333 0 0 0 53.333333-53.333333V533.333333z m-42.058666-277.333333l-89.792-95.402667a32 32 0 0 1 46.613333-43.861333l140.544 149.333333C927.861333 286.485333 913.376 320 885.333333 320H724.704C643.029333 320 576 391.210667 576 480v192a32 32 0 1 1-64 0V480c0-123.296 94.784-224 212.704-224h86.570667z"
            p-id="9671"
          ></path>
        </svg>
      </span>
      <p class="noDataClass" v-show="noData">暂无数据</p>
    </div>
    <BackTop :showBackTop="showBackTop" :clickEvent="goBackTop"></BackTop>
  </div>
</template>

<script>
import {
  https_medalTally_list,
  https_select_delegationList,
  https_sportsList,
} from '@api/platfrom_compreSportsMeet_api'
import marathon_select_opt from '@components/platfromBase/marathon/select_opt.vue'
import BackTop from '@components/base/backTop.vue'
import multiLevelFold_table from '@components/platfromBase/compreSportsMeet/table/multiLevelFold_table.vue'
import cup_base_data_mixin from '@mixins/cup_base_data'
import single_findAnalysisItem_data_mixin from '@mixins/single_findAnalysisItem_data'
export default {
  name: 'compreSportsMeet_medalTally',
  components: {
    multiLevelFold_table,
    BackTop,
    marathon_select_opt,
  },
  mixins: [cup_base_data_mixin, single_findAnalysisItem_data_mixin],
  data() {
    return {
      themeTemplateType: 10,
      isScrollBottom: false,
      tableMode: 'medalTally',
      scrollDomClassName: 'el-table__body-wrapper',
      scrollDomById: 'containerFull_body',
      parentWidthPx: 0,
      parentHeightPx: 0,
      isScrollFlag: false,
      isClickFlag: false,
      variableColWidthVw: 31.25,
      tableCellDefaultWidthVw: 5.55,
      defaultWidthVwNum: null,
      tableColumnData: [],
      tableData: null,
      tableTotal: 0,
      expandKey: 'isExpand',
      isExpandAll: false, //默认全部展示
      showBackTop: false,
      selectAllObj: {
        value: 'all',
        name: '全部',
      },
      currStageBigSports: '',
      currStageDelegation: '',
      bigSportsArr: [],
      delegationArr: [],
      selectOptData: {
        configArr: [
          {
            type: 'bigSports',
            title: '项目',
            origin_keyVal: ['value', 'name'],
            dataName: 'bigSportsArr',
            selectIndex: 0,
            isFilterable: true,
          },
          {
            type: 'delegation',
            title: '代表团',
            origin_keyVal: ['value', 'name'],
            dataName: 'delegationArr',
            selectIndex: 0,
            isFilterable: true,
          },
        ],
        selectOpt_list: [],
      },
      themeList: [],
      themeItem: null,
    }
  },
  mounted() {
    if (this.currGroup) {
      console.debug('init ')
      this.init()
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', () => {
      this.onResizeEvent()
    })
    window.removeEventListener('scroll', () => {
      this.scrollListenerEvent()
    })
  },
  computed: {
    noData() {
      return this.tableData && this.tableData.length == 0
    },
    tableHeightPx() {
      // let clientHeight = window.innerHeight
      //   ? window.innerHeight
      //   : window.screen.height
      //   ? window.screen.height
      //   : 667
      // let clientWidth = window.innerWidth
      //   ? window.innerWidth
      //   : window.screen.width
      //   ? window.screen.width
      //   : 375

      // return Math.floor(clientHeight - (clientWidth / 100) * (42 - 30))
      return 'auto'
    },
  },
  methods: {
    async init() {
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      console.debug(this.currCid, this.currSid)
      // window.addEventListener('resize', () => {
      //   this.onResizeEvent()
      // })
      // await this.findAnalysisItem(this.themeTemplateType)
      this.makeAnalysisItemParams(this.themeTemplateType)
      await this.getBigSportsList()

      await this.getMedalTallyList()
      console.debug(this.stageArr)

      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    makeAnalysisItemParams(themeTemplateType) {
      // 每个页面单独设置不同函数
      this.findAnalysisItemParams = {
        sportType: 'compreSportsMeet',
        templateType: themeTemplateType,
        cid: this.currCid,
        sid: this.currSid,
        did: 0,
        eid: 0,
        pid: 0,
        mid: 0,
      }
      if (this.initSingleFindAnalysisItem) {
        this.initSingleFindAnalysisItem(this.findAnalysisItemParams)
      }
    },
    async findAnalysisItemCallback(resData) {
      // let themeAnalysisItemIdArr = []
      let jsonArr = []
      if (resData && resData.length > 0) {
        this.themeList = resData.map((item) => {
          jsonArr.push(item.json)
          item.actJson = JSON.parse(item.json)
          item.renderData = null
          return item
        })
        this.themeItem = this.themeList[0]
      } else {
        this.themeList = []
        this.themeItem = null
      }

      this.selectOptData = {
        configArr: [
          {
            type: 'bigSports',
            title: '项目',
            origin_keyVal: ['value', 'name'],
            dataName: 'bigSportsArr',
            selectIndex: 0,
            isFilterable: true,
          },
          {
            type: 'delegation',
            title: '代表团',
            origin_keyVal: ['value', 'name'],
            dataName: 'delegationArr',
            selectIndex: 0,
            isFilterable: true,
          },
        ],
        selectOpt_list: [],
      }
      await this.getDelegationList()

      this.computedSelectOpt(this.selectOptData.configArr)
    },
    toParentEventHandler(data) {
      console.debug(data)
    },
    onResizeEvent() {
      if (this.$refs.tableParentDom) {
        this.parentWidthPx = this.$refs.tableParentDom.offsetWidth
      } else {
        console.debug('dom 不存在')
      }
    },
    scrollListenerEvent() {
      const scrollTop = this.scrollAreaDom.scrollTop
      const scrollHeight = this.scrollAreaDom.scrollHeight
      const parentHeightPx = this.scrollAreaDom.offsetHeight
      let direction = this.DIRECTION_ENUM.DOWN
      if (this.beforeScrollTop > scrollTop) {
        direction = this.DIRECTION_ENUM.UP
      }
      // 通过滚动方向判断是触底还是触顶
      // console.debug(
      //   'direction:',
      //   direction,
      //   scrollTop,
      //   parentHeightPx,
      //   scrollHeight,
      //   this.isScrollBottom
      // )

      if (scrollTop > 300) {
        this.showBackTop = true
      } else {
        this.showBackTop = false
      }
      // this.changeMatchLabelFixed(scrollTop, direction)

      if (direction == this.DIRECTION_ENUM.DOWN) {
        // 滚动触底
        if (scrollTop + parentHeightPx + this.threshold >= scrollHeight) {
          console.debug('滚动触底')
          this.isScrollBottom = true
        }
      } else {
        // 滚动到顶部
        this.isScrollBottom = false
        if (scrollTop <= this.threshold) {
          console.debug('滚动到顶部')
        }
      }

      this.beforeScrollTop = this.scrollAreaDom.scrollTop
    },
    goBackTop() {
      if (this.scrollAreaDom) {
        this.scrollAreaDom.scrollTo(0, 0)
      }
    },
    clickPublicTheme() {
      // 分享主题
      if (!['all', ''].includes(this.currStageDelegation)) {
        // 选中某一个代表团；则选数组中第二个主题
        this.themeItem = this.themeList[1]
      } else {
        // 代表团：全部；则选数组中第一个主题
        this.themeItem = this.themeList[0]
      }
      console.debug('themeItem:', this.themeItem, this.themeList)
      let themeItem = JSON.parse(JSON.stringify(this.themeItem))
      if (!themeItem) {
        return
      }
      themeItem.actJson = JSON.parse(themeItem.json)
      const keyArr = Object.keys(themeItem.actJson)
      themeItem.actJson[keyArr[0]] =
        this.currStageBigSports === 'all' ? '' : this.currStageBigSports
      let analysisItemName = themeItem.analysisItemName
      if (this.currStageBigSports !== 'all') {
        let bigSportsName = ''
        this.bigSportsArr.forEach((sportsItem) => {
          if (sportsItem.value === this.currStageBigSports) {
            bigSportsName = sportsItem.name
          }
        })
        analysisItemName = `${analysisItemName}-${bigSportsName}`
        console.debug('baseAnalysisItemName:', bigSportsName, analysisItemName)
      }
      if (!['all', ''].includes(this.currStageDelegation)) {
        themeItem.actJson[keyArr[1]] =
          this.currStageDelegation === 'all' ? '' : this.currStageDelegation
        let delegationName = ''
        this.delegationArr.forEach((delegationItem) => {
          if (delegationItem.value === this.currStageDelegation) {
            delegationName = delegationItem.name
          }
        })
        analysisItemName = `${delegationName}${analysisItemName}`
      }
      console.debug(
        'baseAnalysisItemName:',
        analysisItemName,
        themeItem,
        this.currStageDelegation,
        keyArr
      )
      themeItem.analysisItemName = analysisItemName
      window.mixtmtBase_eventBus.$emit('publicThemeDialogEvent', {
        flag: true,
        themeItem: themeItem,
        mid: themeItem && themeItem.matchId ? themeItem.matchId : 0,
      })
    },
    initScroll() {
      if (this.scrollAreaDom) {
        return
      }
      this.parentWidthPx = this.$refs.tableParentDom.offsetWidth
      console.debug(
        'this.parentWidthPx:',
        this.$refs.tableParentDom.scrollHeight
      )
      this.beforeScrollTop = 0
      this.threshold = 5
      this.DIRECTION_ENUM = {
        DOWN: 'down',
        UP: 'up',
      }
      window.addEventListener('resize', () => {
        this.onResizeEvent()
      })
      // this.scrollAreaDom = document.getElementsByClassName(
      //   `${this.scrollDomClassName}`
      // )[0]

      this.scrollAreaDom = document.getElementById(`${this.scrollDomById}`)

      // console.debug(this.scrollAreaDom)
      this.scrollAreaDom.addEventListener('scroll', () => {
        this.scrollListenerEvent()
      })
    },
    computedSelectOpt(configArr) {
      // 组装选择框数据
      let selectOpt_list = []
      configArr.forEach((config, index) => {
        let disabledArr = []
        const mix_id = `mix_${config.origin_keyVal[0]}`
        let list = this[config.dataName].map((item) => {
          item[mix_id] = `${config.type}_${item[config.origin_keyVal[0]]}`
          return item
        })
        console.debug(
          'computedSelectOpt:',
          config.dataName,
          this[config.dataName],
          list,
          mix_id
        )
        selectOpt_list.push({
          type: config.type,
          title: config.title,
          keyVal: [mix_id, config.origin_keyVal[1]],
          curId: list[config.selectIndex]?.[mix_id], // 选中的id,是改装后的，需要去掉前缀才是源数据的唯一id
          curVal: list[config.selectIndex]?.[config.origin_keyVal[1]], // 这个值是源数据需要展示的值，没有做过修改
          disabledArr, //当【阶段】选择为淘汰赛时，球队这栏置灰；所以在【球队】这组对象的disabledArr=['stage_2']；而【阶段】的disabledArr = []。在marathon_select_opt组件中也需要做一些逻辑处理，主要是对curStageVal这个值
          isFilterable: config.isFilterable ? config.isFilterable : false,
          list,
        })
      })

      this.selectOptData.selectOpt_list = selectOpt_list
      console.debug('this.selectOptData.selectOpt_list', selectOpt_list)
    },
    changeSelect(data) {
      console.debug(data)
      let valPathArr = []
      let val = data.val
      // 选择后，重置联动的筛选框
      if (data.type === 'select') {
        if (val.indexOf('_') > -1) {
          valPathArr = val.split('_')
          for (let i = 0; i < this.selectOptData.selectOpt_list.length; i++) {
            let item = this.selectOptData.selectOpt_list[i]
            const idKey = item.keyVal[0]
            const valKey = item.keyVal[1]
            if (item.type == valPathArr[0]) {
              for (let j = 0; j < item.list.length; j++) {
                let cell = item.list[j]
                console.debug(idKey, val)
                if (cell[idKey] == val) {
                  console.debug(cell[idKey], val)
                  // updateSelectIndex = i
                  item.curVal = cell[valKey]
                  break
                }
              }
            }
          }

          if (valPathArr[0] === 'bigSports') {
            this.currStageBigSports = valPathArr[1]
          } else if (valPathArr[0] === 'delegation') {
            this.currStageDelegation = valPathArr[1]
          } else {
          }

          // 筛选表格逻辑
          // this.initMatchListQuery()
          // this.getScheduleMatchList()
          this.getMedalTallyList()
        } else {
          console.debug('id命名方式不符合组件规则')
        }
      } else {
        console.debug('data.type 没有匹配成功')
      }
    },
    async selectOpt_manualRefresh() {
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      await this.getMedalTallyList()
      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    expandColumnCallback(tableColumnData) {
      let expandColumnData = []
      // 定义第一个展开行，宽度、字段值、class值
      const expand1RowFlexArr = [
        { flex: 0 },
        { flex: 0 },
        { flex: 2, prop: 'sportsName', className: 'sportsNameClass' },
        { flex: 1 },
        { flex: 1 },
        { flex: 1 },
        { flex: 1 },
        { flex: 0 },
        { flex: 2, prop: 'arrow', className: 'arrowIcon' },
      ]

      const expand2RowFlexArr = [
        { flex: 1 },
        { flex: 1 },
        { flex: 0 },
        { flex: 0 },
        { flex: 0 },
        { flex: 0 },
        {
          flex: 5,
          prop: 'medalType-playerName-matchName',
          className: 'medalType-playerName-matchNameClass',
        },
        { flex: 0 },
        { flex: 1, prop: 'zhanwei' },
      ]

      let mergeWidthPx = 0
      let mergeWidthVw = 0
      const expandRowFlexArr = [expand1RowFlexArr, expand2RowFlexArr]
      return expandRowFlexArr.map((expandRowFlexItem) => {
        let expandColumnData = []
        tableColumnData.forEach((columnItem, columnIndex) => {
          if (!expandRowFlexItem[columnIndex].flex) {
            mergeWidthPx += columnItem.widthPx - 0
            mergeWidthVw += columnItem.widthVw - 0
            // console.debug('this.tableColumnData：', mergeWidthPx, mergeWidthVw)
          } else if (expandRowFlexItem[columnIndex].flex > 1) {
            mergeWidthPx += columnItem.widthPx - 0
            mergeWidthVw += columnItem.widthVw - 0
            expandColumnData.push({
              name: '合并',
              prop: expandRowFlexItem[columnIndex].prop, //sportsName,
              widthPx: mergeWidthPx,
              widthVw: mergeWidthVw,
              className: expandRowFlexItem[columnIndex].className,
            })
            mergeWidthPx = 0
            mergeWidthVw = 0
          } else {
            expandColumnData.push({
              name: columnItem.label,
              prop: columnItem.prop,
              widthPx: columnItem.widthPx,
              widthVw: columnItem.widthVw,
              className: columnItem.className,
            })
          }
        })
        return expandColumnData
      })
    },
    computedTableData(data) {
      if (data) {
        this.tableTotal = data ? data.length : 0
        // 表头
        const columns = [
          {
            colKey: 'teamName',
            colTitle: '代表团',
          },
          {
            colKey: 'teamLogo',
            colTitle: '国旗',
          },
          {
            colKey: 'rankNum',
            colTitle: '金牌排名',
          },
          {
            colKey: 'joinNum',
            colTitle: '总数排名',
          },
          {
            colKey: 'gold',
            colTitle: '金牌',
          },
          {
            colKey: 'silver',
            colTitle: '银牌',
          },
          {
            colKey: 'bronze',
            colTitle: '铜牌',
          },
          {
            colKey: 'total',
            colTitle: '奖牌总数',
          },
          {
            colKey: 'arrowIcon',
            colTitle: '',
          },
          {
            colKey: 'isExpand',
            colTitle: '',
          },
        ]
        const fristColumns = columns.slice(0, 2)
        const otherColumns = columns.slice(2)
        this.defaultWidthVwNum = otherColumns.length - 2 //减去这2列[arrowIcon, isExpand]
        if (this.tableColumnData.length == 0) {
          let tableColumnData = []
          let fristColumnPropArr = []
          for (let i = 0; i < fristColumns.length; i++) {
            fristColumnPropArr.push(fristColumns[i].colKey)
          }
          const fristColumn = {
            prop: 'delegationLogo-delegationName', //fristColumnPropArr.join('-'),
            label: '参赛者',
            widthVw: this.variableColWidthVw, //对应列的宽度，单位vw
            className: 'columnNumLogoNameClass', //单独定制的头部样式class
            // fixed: 'left', //是否锁定，如果开启不滚动，此字段无效
          }

          for (let i = 0; i < otherColumns.length; i++) {
            if (i == 2) {
              tableColumnData.push(fristColumn)
            }
            const item = otherColumns[i]
            tableColumnData.push({
              prop: item.colKey,
              label: item.colTitle,
              widthVw: ['arrowIcon', 'isExpand'].includes(item.colKey)
                ? this.tableCellDefaultWidthVw / 2
                : this.tableCellDefaultWidthVw, //单独设置 [arrowIcon, isExpand] 的对应列的宽度，单位vw, 宽度为普通的一半
              className: ['arrowIcon', 'isExpand'].includes(item.colKey)
                ? 'expandTdClassName'
                : '', //单独定制的头部样式class
              selected: '',
            })
          }

          this.tableColumnData = tableColumnData
        }
        const rowHeightVw = 2.778,
          childRowHeightVw = 3.472
        this.tableData = data
          ? data.map((delegation) => {
              let delegationItem = {
                id: delegation.organisationCode,
                delegationName: delegation.organisationName,
                delegationLogo: delegation.organisationLogo,
                rankNum: delegation.rankGold,
                joinNum: delegation.rankMedal,
                gold: delegation.gold,
                silver: delegation.silver,
                bronze: delegation.bronze,
                total: delegation.medal,
                arrowIcon: '',
                isShowChild: this.isExpandAll,
                isHasDetailData: true, //正常只有获得奖牌的国家，在奖牌榜才会显示出来，控制是否有第一级展开
                childKeyArr1: [
                  //展开的第一层key值
                  { prop: 'sportsName' },
                  { prop: 'gold' },
                  { prop: 'silver' },
                  { prop: 'bronze' },
                  { prop: 'total' },
                  { prop: 'arrowIcon' },
                  // { prop: 'isExpand' },
                ],
                childKeyArr2: [
                  //展开的第二层key值
                  { prop: 'random0' },
                  { prop: 'random1' },
                  { prop: 'medalType-playerName-matchName' },
                  { prop: 'random2' },
                ],
                isExpand: {
                  rowHeightVw: rowHeightVw,
                  childRowHeightVw: childRowHeightVw,
                  isSomeChildOpen: false,
                  currHeightVw:
                    delegation.sportsDisciplineMedals &&
                    delegation.sportsDisciplineMedals.length
                      ? delegation.sportsDisciplineMedals.length * rowHeightVw
                      : 0,
                  list: delegation.sportsDisciplineMedals.map((sports) => {
                    return {
                      sportsName: sports.disciplineName,
                      id: sports.disciplineCode,
                      gold: sports.gold,
                      silver: sports.silver,
                      bronze: sports.bronze,
                      total: sports.medal,
                      arrowIcon: '',
                      isOpen: false, //有展开第二层需要加这个字段，控制是否展开
                      currHeightVw:
                        sports.sportsEventMedals &&
                        sports.sportsEventMedals.length
                          ? sports.sportsEventMedals.length * childRowHeightVw
                          : 0,
                      children: sports.sportsEventMedals.map((item, index) => {
                        let plyerName = ''
                        if (['A', 'D'].includes(item.competitorType)) {
                          // 单人 || 双人
                          item.athleteInfos.forEach((player, playerIndex) => {
                            if (playerIndex > 0) {
                              plyerName += `/ ${player.athleteName} `
                            } else {
                              plyerName += `${player.athleteName} `
                            }
                          })
                        } else {
                          // 团队
                          plyerName = delegation.organisationName
                        }
                        return {
                          id: index + 1,
                          playerName: plyerName,
                          medalType: item.medalType,
                          matchName: item.eventName,
                        }
                      }),
                    }
                  }),
                  // list: [
                  //   //这个字段控制是否有第一层展开
                  //   {
                  //     sportsName: '田径',
                  //     id: 'as',
                  //     gold: 1,
                  //     silver: 1,
                  //     bronze: 4,
                  //     total: 6,
                  //     arrowIcon: 'aa',
                  //     isOpen: false, //有展开第二层需要加这个字段，控制是否展开
                  //     currHeightVw: 2*3.472,
                  //     children: [
                  //       //第二层展开的内容
                  //       {
                  //         id: 1,
                  //         playerName: '王子晨',
                  //         medalType: 'gold',
                  //         matchName: '男子个人全能',
                  //       },
                  //       {
                  //         id: 2,
                  //         playerName: '王子晨',
                  //         medalType: 'silver',
                  //         matchName: '田径男子个人全能',
                  //       },
                  //     ],
                  //   },
                  //   {
                  //     sportsName: '篮球',
                  //     id: 'bbk',
                  //     gold: 1,
                  //     silver: 1,
                  //     bronze: 4,
                  //     total: 6,
                  //     arrowIcon: 'aas',
                  //     isOpen: false, //有展开第二层需要加这个字段，控制是否展开
                  //     currHeightVw: 3.472,
                  //     children: [
                  //       //第二层展开的内容
                  //       {
                  //         id: 1,
                  //         playerName: '王子晨',
                  //         medalType: 'gold',
                  //         matchName: '男子个人全能',
                  //       },
                  //     ],
                  //   },
                  // ],
                },
              }
              return delegationItem
            })
          : [
              // {
              //   id: 10001,
              //   delegationName: '中国',
              //   delegationLogo: '',
              //   rankNum: '1',
              //   joinNum: 10,
              //   gold: 8,
              //   silver: 6,
              //   bronze: 4,
              //   total: 18,
              //   arrowIcon: '',
              //   isShowChild: false,
              //   childKeyArr1: [
              //     //展开的第一层key值
              //     { prop: 'sportsName' },
              //     { prop: 'gold' },
              //     { prop: 'silver' },
              //     { prop: 'bronze' },
              //     { prop: 'total' },
              //     { prop: 'arrowIcon' },
              //     { prop: 'isExpand' },
              //   ],
              //   childKeyArr2: [
              //     //展开的第二层key值
              //     { prop: 'random0' },
              //     { prop: 'random1' },
              //     { prop: 'medalType-playerName-matchName' },
              //     { prop: 'random2' },
              //   ],
              //   isExpand: {
              //     rowHeightVw: 2.778,
              //     childRowHeightVw: 3.472,
              //     isSomeChildOpen: false,
              //     currHeightVw: 2 * 2.778,
              //     list: [
              //       //这个字段控制是否有第一层展开
              //       {
              //         sportsName: '田径',
              //         id: 'as',
              //         gold: 1,
              //         silver: 1,
              //         bronze: 4,
              //         total: 6,
              //         arrowIcon: 'aa',
              //         isOpen: false, //有展开第二层需要加这个字段，控制是否展开
              //         currHeightVw: 2 * 3.472,
              //         children: [
              //           //第二层展开的内容
              //           {
              //             id: 1,
              //             playerName: '王子晨',
              //             medalType: 'gold',
              //             matchName: '男子个人全能',
              //           },
              //           {
              //             id: 2,
              //             playerName: '王子晨',
              //             medalType: 'silver',
              //             matchName: '田径男子个人全能',
              //           },
              //         ],
              //       },
              //       {
              //         sportsName: '篮球',
              //         id: 'bbk',
              //         gold: 1,
              //         silver: 1,
              //         bronze: 4,
              //         total: 6,
              //         arrowIcon: 'aas',
              //         isOpen: false, //有展开第二层需要加这个字段，控制是否展开
              //         currHeightVw: 3.472,
              //         children: [
              //           //第二层展开的内容
              //           {
              //             id: 1,
              //             playerName: '王子晨',
              //             medalType: 'gold',
              //             matchName: '男子个人全能',
              //           },
              //         ],
              //       },
              //     ],
              //   },
              // },
            ]
        // this.$refs.tableParentDom.scrollTo(0, 0)
        console.debug('this.tableData:', this.tableData)
      } else {
        console.debug('暂无数据')
      }
    },
    async getBigSportsList() {
      await https_sportsList(this.axiosBaseUrl, this.$axios, {
        sid: this.currSid,
      })
        .then((response) => {
          const res = response.data
          console.debug('response:', res)
          if (res.status === 0) {
            if (res.data) {
              let selectAllObj = JSON.parse(JSON.stringify(this.selectAllObj))
              this.bigSportsArr = res.data
                ? [].concat(
                    selectAllObj,
                    res.data.map((item) => {
                      return {
                        value: item.disciplineCode,
                        name: item.disciplineName,
                      }
                    })
                  )
                : []
              if (this.bigSportsArr.length > 0) {
                this.currStageBigSports = this.bigSportsArr[0].value
              }
            }
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    async getMedalTallyList() {
      await https_medalTally_list(this.axiosBaseUrl, this.$axios, {
        cid: this.currCid,
        sid: this.currSid,
        sportsId:
          this.currStageBigSports === 'all' ? '' : this.currStageBigSports,
        delegationId:
          this.currStageDelegation === 'all' ? '' : this.currStageDelegation,
      })
        .then((response) => {
          const res = response.data
          console.debug('response:', res)
          if (res.status === 0) {
            if (res.data) {
              // this.themeList = res.data.analysisItems
              // this.themeItem =
              //   this.themeList && this.themeList.length > 0
              //     ? this.themeList[0]
              //     : null
              this.$nextTick(() => {
                this.onResizeEvent()
                this.computedTableData(res.data.dataLit)
                // this.computedTableData(mockData.data)
                this.initScroll()
              })
            } else {
              console.debug('暂无数据')
            }
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    async getDelegationList() {
      let params = {
        sid: this.currSid,
      }
      await https_select_delegationList(this.axiosBaseUrl, this.$axios, params)
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            let selectAllObj = JSON.parse(JSON.stringify(this.selectAllObj))
            this.delegationArr = res.data
              ? [].concat(
                  selectAllObj,
                  res.data.map((item) => {
                    return {
                      value: item.organisationCode,
                      name: item.organisationName,
                    }
                  })
                )
              : []
            if (this.delegationArr.length > 0) {
              this.currStageDelegation = this.delegationArr[0].value
            }
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
  },
}
</script>

<style lang="scss" scoped>
#compreSportsMeet_medalTally {
  .select_area {
    position: relative;
    padding-top: 2.778vw;
    width: 100%;
    height: 9.028vw;
    .switch_area {
      position: absolute;
      top: 2.778vw;
      right: 0;
      z-index: 10;
    }
  }
  .tableScrollArea {
    position: relative;
    padding: 1.388vw 0 6.964vw;
    .publishBtn {
      position: absolute;
      right: 0;
      top: 1.388vw;
      z-index: 2;
      display: flex;
      display: -webkit-flex;
      justify-content: center;
      align-items: center;
      font-weight: bold;
      width: 5.55vw;
      height: 2.778vw;
      svg.publishBtn_icon {
        fill: var(--mixtmt_whiteColor);
        /* fill: var(--mixtmt_greyColor4); */
      }
    }
  }

  .loadingClass,
  .noMoreClass,
  .noDataClass {
    position: absolute;
    bottom: -4.166vw;
    left: 0;
    z-index: 2;
    width: 100%;
    line-height: 4.166vw;
    text-align: center;
    font-size: 0.972vw;
    color: var(--mixtmt_greyColor2);
  }
  .noDataClass {
    border-top: 1px solid var(--mixtmt_greyColor0);
    border-bottom: 1px solid var(--mixtmt_greyColor0);
  }
}

.mixtmt_pc #compreSportsMeet_medalTally {
  .publishBtn {
    &:hover {
      cursor: pointer;
      svg.publishBtn_icon {
        fill: var(--mixtmt_greyColor4);
      }
    }
  }
}
</style>
